<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" class="mt-3" >
      <el-tab-pane label="Cambiar Contrseña" name="password">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="20" v-if="!form.id">
            <el-col :span="12">
              <el-form-item label="Nueva contraseña" prop="password">
                <el-input type="password"
                          v-model="form.password"
                          auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Confirmación" prop="password_confirmation">
                <el-input type="password"
                          v-model="form.password_confirmation"
                          auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-button type="primary"
                     @click="savePassword()"
                     :loading="processing">
            Guardar
          </el-button>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {baseApi} from '../../configs/urls'

  export default {
    name: 'app-account',
    data () {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Por favor ingresa la contraseña'))
        } else {
          if (this.form.password_confirmation !== '') {
            this.$refs.form.validateField('password_confirmation')
          }
          callback()
        }
      }

      const validatePassConfirmation = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Ingresa la contraseña otra vez'))
        } else if (value !== this.form.password) {
          callback(new Error('La confirmacion no coincide!'))
        } else {
          callback()
        }
      }
      return {
        activeName: 'password',
        processing: false,
        form: {},
        rules: {
          password: [
            { required: true, message: 'La contraseña es requerida', trigger: 'blur' },
            { min: 8, message: 'Por lo menos debe tener 8 caracters', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ],
          password_confirmation: [
            { validator: validatePassConfirmation, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      savePassword () {
        this.processing = true
        this.$http.post(baseApi + '/changepasswd', this.form)
          .then(
            () => {
              this.form = {}
              this.$message({
                type: 'success',
                message: 'Se cambio la contraseña exitosamente.'
              })
              this.processing = false
            },
            () => {
              this.$message({
                type: 'error',
                message: 'Vefica que los datos esten correctos.'
              })
              this.processing = false
            }
          )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/Account.vue